import React, { useState, useEffect } from "react";
import { Outlet, Link } from "react-router-dom";
import "./styles/layout.css";
import LoadingOverlay from "./components/LoadingOverlay";

const Layout = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="app-container">
      <LoadingOverlay visible={loading} />

      {/* HEADER WITH INLINE NAV */}
      <header className="header header-flex">
        {/* Left side: App Name + Date */}
        <div className="header-left">
          <h1>RCS RECEIVABLES</h1>
          <span className="date-display">
            {new Date().toLocaleDateString("en-US", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </span>
        </div>

        {/* Right Side: Navigation */}
        <nav className="header-nav">
          <Link to="/">Home</Link>
          <Link to="/clients">Clients</Link>
          <Link to="/invoices">Invoices</Link>
          <Link to="/payments">Payments</Link>
          <Link to="/reports">Reports</Link>
          <Link to="/settings">Settings</Link>
        </nav>
      </header>

      {/* MAIN CONTENT — FULL WIDTH */}
      <main className="content full-width">
        <div className="home-container">
          <Outlet />
        </div>
      </main>

      <footer className="footer">
        <p>RCS ALL RIGHTS RESERVED © {new Date().getFullYear()}</p>
      </footer>
    </div>
  );
};

export default Layout;
